<div class="accounting-stripe-page p-6 bg-gray-50 min-h-screen">
  <div class="header-row flex items-center justify-between px-6">
    <mat-tab-group
      mat-stretch-tabs="false"
      animationDuration="0ms"
      class="rounded-lg overflow-hidden tab-group"
      (selectedTabChange)="onTabChange($event)"
    >
      <mat-tab label="Payments">
        <div class="p-3 rounded-b-lg stripe-tab-content">
          <app-transactions-table
            [transactions]="displayedTransactions"
            [columns]="displayedColumns"
            (sort)="onSort($event)"
          ></app-transactions-table>
        </div>
      </mat-tab>
      <mat-tab label="Payouts">
        <div class="p-3 rounded-b-lg stripe-tab-content">
          <app-transactions-table
            [transactions]="displayedTransactions"
            [columns]="displayedColumns"
            (sort)="onSort($event)"
          ></app-transactions-table>
        </div>
      </mat-tab>
      <mat-tab label="Stripe Fee">
        <div class="p-3 rounded-b-lg strip-tab-content">
          <app-transactions-table
            [transactions]="stripeFeeData"
            [columns]="stripeFeeColumns"
            (sort)="onSort($event)"
          ></app-transactions-table>
        </div>
      </mat-tab>
      <mat-tab label="Transfer">
        <div class="p-3 rounded-b-lg strip-tab-content">
          <app-transactions-table
            [transactions]="displayedTransactions"
            [columns]="displayedColumns"
            (sort)="onSort($event)"
          ></app-transactions-table>
        </div>
      </mat-tab>
      <mat-tab label="All Transactions">
        <div class="p-3 rounded-b-lg">
          <app-transactions-table
            [transactions]="displayedTransactions"
            [columns]="displayedColumns"
            (sort)="onSort($event)"
          >
          </app-transactions-table>
        </div>
      </mat-tab>
    </mat-tab-group>
    <div
      class="date-range-filter flex space-x-2"
      [ngClass]="{
        'with-type': isTypeOfPayment,
        'without-type': !isTypeOfPayment,
      }"
      [formGroup]="stripeDataForm"
    >
      @if (isTypeOfPayment) {
        <mat-form-field appearance="outline" class="type-field">
          <mat-select
          formControlName="filterType"
          name="payment_type"
          (valueChange)="paymentTypeChange($event)"
          >
          @for (type of typesOfPayments; track type) {
              @if (selectedTab === 'payment' && type.visible  && type.paymentVisible) {
                <mat-option [value]="type.value">{{ type.viewValue }}</mat-option>
              } @else if (selectedTab === 'transfer' && type.visible && type.transferVisible) {
                <mat-option [value]="type.value">{{ type.viewValue }}</mat-option>
              }
            }
          </mat-select>
        </mat-form-field>
      }
      <mat-form-field appearance="outline" class="date-field">
        <span matPrefix (click)="openDatePicker()">
          <img
            src="../../../../assets/icons/shooting-schedule.png"
            alt="Date Icon"
            class="date-icon"
          />
        </span>
        <mat-date-range-input
           [rangePicker]="stripeDatePicker"
          [min]="minDate"
          [max]="maxDate"
          (click)="openDatePicker()"
        >
          <input
            matStartDate
            placeholder="Start date"
            formControlName="startDate"
          />
          <input
            matEndDate
            placeholder="End date"
            formControlName="endDate"
            (dateChange)="onDateRangeChange()"
            (keydown)="$event.preventDefault()"
            (paste)="$event.preventDefault()"
          />
        </mat-date-range-input>
        <mat-date-range-picker #stripeDatePicker></mat-date-range-picker>
      </mat-form-field>
    </div>
  </div>
  <div class="rounded-lg stripe-pagination-content flex justify-end">
    <app-pagination-table
      class="rounded-lg bg-white table-pagination-fixed"
      [totalResults]="totalResults"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageOffset]="pageOffset"
      (pageChange)="onPageChange($event)"
    >
    </app-pagination-table>
  </div>
</div>
